/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Image, Text } from "@aws-amplify/ui-react";
import Thumbsdown from "./Thumbsdown";
export default function GuaranteeMobile(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="40px"
      direction="column"
      width="402px"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="50px 20px 50px 20px"
      backgroundColor="rgba(244,244,244,1)"
      {...getOverrideProps(overrides, "GuaranteeMobile")}
      {...rest}
    >
      <Flex
        gap="33px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464750")}
      >
        <Flex
          gap="16px"
          direction="column"
          width="358px"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 110")}
        >
          <Flex
            gap="8px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464772")}
          >
            <Text
              fontFamily="THICCCBOI"
              fontSize="18px"
              fontWeight="700"
              color="rgba(204,164,59,1)"
              textTransform="uppercase"
              lineHeight="28px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              letterSpacing="1.29px"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="we guarantee"
              {...getOverrideProps(overrides, "we guarantee")}
            ></Text>
            <Text
              fontFamily="Inter"
              fontSize="32px"
              fontWeight="700"
              color="rgba(30,27,27,1)"
              lineHeight="48px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="You’ll Never Endure The Drudgery of Finding a Job Again."
              {...getOverrideProps(
                overrides,
                "You\u2019ll Never Endure The Drudgery of Finding a Job Again."
              )}
            ></Text>
          </Flex>
          <Text
            fontFamily="Inter"
            fontSize="20px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="30px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="-0.25px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Do you deserve to spend all day wasting your time applying for jobs, never hearing back, getting no interest and no clue why you’re not getting any interviews? Of course not!"
            {...getOverrideProps(
              overrides,
              "Do you deserve to spend all day wasting your time applying for jobs, never hearing back, getting no interest and no clue why you\u2019re not getting any interviews? Of course not!"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="27.200000762939453px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Your enemy is an “Applicant Tracking System,” and just ONE wrong keyword in your application is all it takes rip a great job you deserve right out of your hands! Great system, eh?"
            {...getOverrideProps(
              overrides,
              "Your enemy is an \u201CApplicant Tracking System,\u201D and just ONE wrong keyword in your application is all it takes rip a great job you deserve right out of your hands! Great system, eh?"
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="16px"
            fontWeight="400"
            color="rgba(31,31,31,1)"
            lineHeight="27.200000762939453px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="Rhealize is turning up the heat on unfair, out-dated, “old school” HR and creating a new, future - today!"
            {...getOverrideProps(
              overrides,
              "Rhealize is turning up the heat on unfair, out-dated, \u201Cold school\u201D HR and creating a new, future - today!"
            )}
          ></Text>
          <Flex
            gap="0"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            borderRadius="8px"
            padding="12px 32px 12px 32px"
            backgroundColor="rgba(203,163,58,1)"
            {...getOverrideProps(overrides, "ButtonTesting")}
          >
            <Text
              fontFamily="Inter"
              fontSize="22px"
              fontWeight="700"
              color="rgba(255,255,255,1)"
              lineHeight="33px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="Let the job find you!"
              {...getOverrideProps(overrides, "label")}
            ></Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        padding="0px 0px 0px 0px"
        width="676px"
        height="505px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Item")}
      >
        <Flex
          gap="9.957082748413086px"
          direction="column"
          width="261px"
          height="159px"
          justifyContent="flex-start"
          alignItems="flex-start"
          overflow="hidden"
          position="absolute"
          top="346px"
          left="415px"
          border="0.47px SOLID rgba(200,211,223,1)"
          boxShadow="0px 2.6996467113494873px 2.6996467113494873px rgba(0, 0, 0, 0.25)"
          borderRadius="10.79858684539795px"
          padding="19.52585318684578px 14.698551207780838px 14.698551207780838px 14.698551207780838px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 1160464556743223526")}
        >
          <Flex
            gap="3.7931745052337646px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464559743223527")}
          >
            <Flex
              gap="3.7931745052337646px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="space-between"
              alignItems="flex-start"
              shrink="0"
              alignSelf="stretch"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464557743223528")}
            >
              <Flex
                gap="1.8965872526168823px"
                direction="column"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                grow="1"
                shrink="1"
                basis="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464560743223529")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="9.482935905456543px"
                  fontWeight="600"
                  color="rgba(31,31,31,1)"
                  lineHeight="10.431229591369629px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Senior UX Designer"
                  {...getOverrideProps(
                    overrides,
                    "Senior UX Designer743223530"
                  )}
                ></Text>
                <Flex
                  gap="9.957082748413086px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  shrink="0"
                  alignSelf="stretch"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  {...getOverrideProps(overrides, "Frame 1160464558743223531")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="6.638054847717285px"
                    fontWeight="400"
                    color="rgba(13,26,38,1)"
                    lineHeight="9.957082748413086px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Whyworks . Full Time"
                    {...getOverrideProps(
                      overrides,
                      "Whyworks . Full Time743223532"
                    )}
                  ></Text>
                  <Text
                    fontFamily="Inter"
                    fontSize="6.638054847717285px"
                    fontWeight="400"
                    color="rgba(13,26,38,1)"
                    lineHeight="9.957082748413086px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    grow="1"
                    shrink="1"
                    basis="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Edmonton, Alberta"
                    {...getOverrideProps(
                      overrides,
                      "Edmonton, Alberta743223533"
                    )}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap="7.112202167510986px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464555743223534")}
          >
            <Flex
              width="unset"
              height="unset"
              {...getOverrideProps(overrides, "AddedSkill743223535")}
            ></Flex>
            <Flex
              width="unset"
              height="unset"
              {...getOverrideProps(overrides, "AddedSkill743223536")}
            ></Flex>
            <Flex
              width="unset"
              height="unset"
              {...getOverrideProps(overrides, "AddedSkill743223537")}
            ></Flex>
          </Flex>
          <Text
            fontFamily="Inter"
            fontSize="7.586349010467529px"
            fontWeight="400"
            color="rgba(92,102,112,1)"
            lineHeight="11.379523277282715px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            letterSpacing="0px"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="We are seeking a creative and experienced Mobile Designer to bring our vision to life. Our app, aims to connect users, providing a dynamic platform"
            {...getOverrideProps(
              overrides,
              "We are seeking a creative and experienced Mobile Designer to bring our vision to life. Our app, aims to connect users, providing a dynamic platform743223538"
            )}
          ></Text>
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "Button743223539")}
          ></Flex>
        </Flex>
        <Flex
          gap="14.993518829345703px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          position="absolute"
          top="0px"
          left="0px"
          border="0.93px SOLID rgba(71,160,80,1)"
          boxShadow="0px 3.720099925994873px 3.720099925994873px rgba(0, 0, 0, 0.25)"
          borderRadius="11.160299301147461px"
          padding="13.950374722480774px 8.370225071907043px 13.950374722480774px 8.370225071907043px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 1160464561")}
        >
          <Flex
            gap="2.608954906463623px"
            direction="column"
            width="unset"
            height="20.61px"
            justifyContent="space-between"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            border="0.26px SOLID rgba(71,160,80,1)"
            borderRadius="1.0435819625854492px"
            padding="3.6525368690490723px 6.338518381118774px 3.6525368690490723px 6.338518381118774px"
            backgroundColor="rgba(255,255,255,1)"
            {...getOverrideProps(overrides, "Frame 427318909743223541")}
          >
            <Flex
              gap="1.826268196105957px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318911743223542")}
            >
              <Text
                fontFamily="Inter"
                fontSize="8.609550476074219px"
                fontWeight="700"
                color="rgba(0,0,0,1)"
                lineHeight="12.914325714111328px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="98%"
                {...getOverrideProps(overrides, "98%743223543")}
              ></Text>
              <Flex
                gap="2.608954906463623px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 427318934743223544")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="5.217909812927246px"
                  fontWeight="600"
                  color="rgba(0,0,0,1)"
                  lineHeight="5.661432266235352px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Match"
                  {...getOverrideProps(overrides, "Match743223545")}
                ></Text>
                <Flex
                  gap="2.608954906463623px"
                  direction="row"
                  width="unset"
                  height="unset"
                  justifyContent="center"
                  alignItems="center"
                  overflow="hidden"
                  shrink="0"
                  position="relative"
                  borderRadius="1.826268196105957px"
                  padding="0.5217909812927246px 2.0871639251708984px 0.5217909812927246px 2.0871639251708984px"
                  backgroundColor="rgba(71,160,80,1)"
                  {...getOverrideProps(overrides, "Frame 427318910743223546")}
                >
                  <Text
                    fontFamily="Inter"
                    fontSize="5.217909812927246px"
                    fontWeight="600"
                    color="rgba(255,255,255,1)"
                    lineHeight="5.661432266235352px"
                    textAlign="left"
                    display="block"
                    direction="column"
                    justifyContent="unset"
                    width="unset"
                    height="unset"
                    gap="unset"
                    alignItems="unset"
                    shrink="0"
                    position="relative"
                    padding="0px 0px 0px 0px"
                    whiteSpace="pre-wrap"
                    children="Top 10"
                    {...getOverrideProps(overrides, "Top 10743223547")}
                  ></Text>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "Button743223548")}
          ></Flex>
          <Thumbsdown
            width="20.62px"
            height="20.62px"
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            property1="Default"
            {...getOverrideProps(overrides, "Thumbsdown743223549")}
          ></Thumbsdown>
        </Flex>
      </Flex>
      <Flex
        gap="10px"
        direction="row"
        width="358px"
        height="479px"
        justifyContent="flex-start"
        alignItems="flex-start"
        overflow="hidden"
        shrink="0"
        position="relative"
        borderRadius="8px"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 1160464778")}
      >
        <Image
          width="358px"
          height="622px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          objectFit="unset"
          {...getOverrideProps(overrides, "AdobeStock_178517791 1")}
        ></Image>
      </Flex>
      <Flex
        gap="14.993518829345703px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        border="0.93px SOLID rgba(71,160,80,1)"
        boxShadow="0px 3.720099925994873px 3.720099925994873px rgba(0, 0, 0, 0.25)"
        borderRadius="11.160299301147461px"
        padding="13.950374722480774px 8.370225071907043px 13.950374722480774px 8.370225071907043px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "Frame 1160464777")}
      >
        <Flex
          gap="2.608954906463623px"
          direction="column"
          width="unset"
          height="20.61px"
          justifyContent="space-between"
          alignItems="flex-start"
          overflow="hidden"
          shrink="0"
          position="relative"
          border="0.26px SOLID rgba(71,160,80,1)"
          borderRadius="1.0435819625854492px"
          padding="3.6525368690490723px 6.338518381118774px 3.6525368690490723px 6.338518381118774px"
          backgroundColor="rgba(255,255,255,1)"
          {...getOverrideProps(overrides, "Frame 427318909743223742")}
        >
          <Flex
            gap="1.826268196105957px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="center"
            alignItems="center"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 427318911743223743")}
          >
            <Text
              fontFamily="Inter"
              fontSize="8.609550476074219px"
              fontWeight="700"
              color="rgba(0,0,0,1)"
              lineHeight="12.914325714111328px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="98%"
              {...getOverrideProps(overrides, "98%743223744")}
            ></Text>
            <Flex
              gap="2.608954906463623px"
              direction="row"
              width="unset"
              height="unset"
              justifyContent="center"
              alignItems="center"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 427318934743223745")}
            >
              <Text
                fontFamily="Inter"
                fontSize="5.217909812927246px"
                fontWeight="600"
                color="rgba(0,0,0,1)"
                lineHeight="5.661432266235352px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Match"
                {...getOverrideProps(overrides, "Match743223746")}
              ></Text>
              <Flex
                gap="2.608954906463623px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="center"
                alignItems="center"
                overflow="hidden"
                shrink="0"
                position="relative"
                borderRadius="1.826268196105957px"
                padding="0.5217909812927246px 2.0871639251708984px 0.5217909812927246px 2.0871639251708984px"
                backgroundColor="rgba(71,160,80,1)"
                {...getOverrideProps(overrides, "Frame 427318910743223747")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="5.217909812927246px"
                  fontWeight="600"
                  color="rgba(255,255,255,1)"
                  lineHeight="5.661432266235352px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Top 10"
                  {...getOverrideProps(overrides, "Top 10743223748")}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          width="unset"
          height="unset"
          {...getOverrideProps(overrides, "Button743223749")}
        ></Flex>
        <Thumbsdown
          width="20.62px"
          height="20.62px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          overflow="hidden"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          property1="Default"
          {...getOverrideProps(overrides, "Thumbsdown743223750")}
        ></Thumbsdown>
      </Flex>
      <Flex
        gap="9.957082748413086px"
        direction="column"
        width="261px"
        height="159px"
        justifyContent="flex-start"
        alignItems="flex-start"
        overflow="hidden"
        shrink="0"
        position="relative"
        border="0.47px SOLID rgba(200,211,223,1)"
        boxShadow="0px 2.6996467113494873px 2.6996467113494873px rgba(0, 0, 0, 0.25)"
        borderRadius="10.79858684539795px"
        padding="19.52585318684578px 14.698551207780838px 14.698551207780838px 14.698551207780838px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "Frame 1160464556743223692")}
      >
        <Flex
          gap="3.7931745052337646px"
          direction="column"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464559743223693")}
        >
          <Flex
            gap="3.7931745052337646px"
            direction="row"
            width="unset"
            height="unset"
            justifyContent="space-between"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 1160464557743223694")}
          >
            <Flex
              gap="1.8965872526168823px"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              grow="1"
              shrink="1"
              basis="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 1160464560743223695")}
            >
              <Text
                fontFamily="Inter"
                fontSize="9.482935905456543px"
                fontWeight="600"
                color="rgba(31,31,31,1)"
                lineHeight="10.431229591369629px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="Senior UX Designer"
                {...getOverrideProps(overrides, "Senior UX Designer743223696")}
              ></Text>
              <Flex
                gap="9.957082748413086px"
                direction="row"
                width="unset"
                height="unset"
                justifyContent="flex-start"
                alignItems="flex-start"
                shrink="0"
                alignSelf="stretch"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "Frame 1160464558743223697")}
              >
                <Text
                  fontFamily="Inter"
                  fontSize="6.638054847717285px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="9.957082748413086px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Whyworks . Full Time"
                  {...getOverrideProps(
                    overrides,
                    "Whyworks . Full Time743223698"
                  )}
                ></Text>
                <Text
                  fontFamily="Inter"
                  fontSize="6.638054847717285px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="9.957082748413086px"
                  textAlign="left"
                  display="block"
                  direction="column"
                  justifyContent="unset"
                  width="unset"
                  height="unset"
                  gap="unset"
                  alignItems="unset"
                  grow="1"
                  shrink="1"
                  basis="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Edmonton, Alberta"
                  {...getOverrideProps(overrides, "Edmonton, Alberta743223699")}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          gap="7.112202167510986px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Frame 1160464555743223700")}
        >
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "AddedSkill743223701")}
          ></Flex>
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "AddedSkill743223702")}
          ></Flex>
          <Flex
            width="unset"
            height="unset"
            {...getOverrideProps(overrides, "AddedSkill743223703")}
          ></Flex>
        </Flex>
        <Text
          fontFamily="Inter"
          fontSize="7.586349010467529px"
          fontWeight="400"
          color="rgba(92,102,112,1)"
          lineHeight="11.379523277282715px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          letterSpacing="0px"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="We are seeking a creative and experienced Mobile Designer to bring our vision to life. Our app, aims to connect users, providing a dynamic platform"
          {...getOverrideProps(
            overrides,
            "We are seeking a creative and experienced Mobile Designer to bring our vision to life. Our app, aims to connect users, providing a dynamic platform743223704"
          )}
        ></Text>
        <Flex
          width="unset"
          height="unset"
          {...getOverrideProps(overrides, "Button743223705")}
        ></Flex>
      </Flex>
    </Flex>
  );
}
